<!-- <template>
  <div
    class="bg-white rounded-xl border overflow-hidden p-1 w-full cursor-pointer hover:border-blue-600"
    :class="{'border-blue-600': checked}">
    <div class="flex p-1">
      <div class="md:flex-shrink-0">
        <img class="h-12 w-12 rounded-xl object-cover"
          :src="imgSrc"
        >
      </div>
      <div class="mx-4">
        <p class="text-gray-800 text-xs">{{ title }}</p>
        <p class="text-gray-500 text-xs">{{ id }}</p>
      </div>
    </div>
  </div>
</template> -->
<loading :active="this.allPageLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="true"
        :color="'#fff'"
        :background-color="'#000'"
        :opacity="'0.8'"
        :loader=" dots">
</loading>
<template>
  <div
    class="bg-white rounded-xl overflow-hidden p-1 w-full cursor-pointer hover:border-blue-600"
    :class="[
      checked ? 'border-t-4 border-r border-b-4 border-l border-blue-600' : 'border'
    ]"
  >
    <div class="account-card relative flex p-1">
      <div class="md:flex-shrink-0">
        <img class="h-12 w-12 rounded-xl object-cover" :src="imgSrc" />
      </div>
      <div class="mx-4">
        <p class="text-gray-800 text-xs">{{ title }}</p>
        <p class="text-gray-500 text-xs">{{ id }}</p>
      </div>

      <i
        v-if="this.deleteStatus"
        class="absolute top-1 right-2 pi pi-times text-gray-600 opacity-0 transition duration-500"
        @click="removeItem(adaccountId, title, id)"
      ></i>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.account-card:hover i.pi-times {
  @apply opacity-100;
}
</style>

<script>
  import Checkbox from "primevue/checkbox";
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'Card',
    components: {
      Checkbox,
      Swal,
      Loading
    },
    props: {
      imgSrc: {
        type: String,
        default: 'http://placehold.it/100x100'
      },
      title: {
        type: String,
        default: 'autoturn'
      },
      id: {
        type: String,
        default: '112233445566'
      },
      adaccountId: {
        type: String,
        default: ''
      },
      checked: {
        type: Boolean,
        default: false
      },
      deleteStatus: {
        type: Boolean,
        default: true
      },
      lang: {
        type: Object
      },
    },
    data() {
      return {
        allPageLoading: false,
        isChecked: false
      };
    },
    methods: {
      removeItem(adaccountId, title, id){
        // console.log(adaccountId+" && "+id);

        let member_hash = this.$route.params.id
        let type = this.$route.params.type

        axios
          .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
            s_code: member_hash,
            route_type: type,
            active: 'member',
          }))
          .then((caResponse) => {

            if(caResponse.data.status == 'error'){
              if(caResponse.data.type == 2){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['Card']['removeItem']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://dev-private.autoturn.net/"+type+"/"+member_hash;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "https://dev-private.autoturn.net/"+type+"/"+member_hash;
                  }
                })
              } else if(caResponse.data.type == 3){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['Card']['removeItem']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  // if (result.isConfirmed) {
                  //   // Swal.fire('Saved!', '', 'success')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // } else if (result.isDenied) {
                  //   // Swal.fire('Changes are not saved', '', 'info')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }

                  // if (result.dismiss === Swal.DismissReason.timer) {
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }
                })
              } else {
                Swal.fire(
                          this.lang['components']['LinkAccount']['Card']['removeItem']['error']['swal_title'],
                          caResponse.data.info,
                          caResponse.data.status
                        )
              }
            }

            if(caResponse.data.status == 'warning'){
              Swal.fire({
                icon: 'warning',
                title: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  Swal.fire({
                    title: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['is_confirmed_title_a']+title+this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['is_confirmed_title_b'],
                    html: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['is_confirmed_html_a']+title+this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['is_confirmed_html_b'],
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['yes_button'],
                    cancelButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['no_button'],
                  }).then((result) => {
                    if (result.isConfirmed) {
                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/data/identity_unlink_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          adaccount_id: adaccountId,
                          page_id: id
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          // if(response.data.status == 'success'){
                            // Swal.fire(
                            //   "刪除「"+name+"」廣告帳戶連結",
                            //   response.data.info,
                            //   response.data.status
                            // )
                          // }
                            Swal.fire({
                              icon: response.data.status,
                              title: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['fan_adaccount_remove_item']['is_confirmed_title_a']+title+this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['fan_adaccount_remove_item']['is_confirmed_title_b'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['warning']['fan_adaccount_remove_item']['is_confirmed_confirm_button'],
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')
                                this.allPageLoading = true;
                                window.location.reload();
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                                this.allPageLoading = true;
                                window.location.reload();
                              }
                            })
                        });
                    }
                  })
                }
              });
            }

            if(caResponse.data.status == 'success'){
              Swal.fire({
                title: this.lang['components']['LinkAccount']['Card']['removeItem']['success']['is_confirmed_title_a']+title+this.lang['components']['LinkAccount']['Card']['removeItem']['success']['is_confirmed_title_b'],
                html: this.lang['components']['LinkAccount']['Card']['removeItem']['success']['is_confirmed_html_a']+title+this.lang['components']['LinkAccount']['Card']['removeItem']['success']['is_confirmed_html_b'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['success']['yes_button'],
                cancelButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['success']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/identity_unlink_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      adaccount_id: adaccountId,
                      page_id: id
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      // if(response.data.status == 'success'){
                        // Swal.fire(
                        //   "刪除「"+name+"」廣告帳戶連結",
                        //   response.data.info,
                        //   response.data.status
                        // )
                      // }
                        Swal.fire({
                          icon: response.data.status,
                          title: this.lang['components']['LinkAccount']['Card']['removeItem']['success']['fan_adaccount_remove_item']['is_confirmed_title_a']+title+this.lang['components']['LinkAccount']['Card']['removeItem']['success']['fan_adaccount_remove_item']['is_confirmed_title_b'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['success']['fan_adaccount_remove_item']['is_confirmed_confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true;
                            window.location.reload();
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true;
                            window.location.reload();
                          }
                        })
                    });
                }
              })
            }

            if(caResponse.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.lang['components']['LinkAccount']['Card']['removeItem']['login']['swal_title'],
                text: this.lang['components']['LinkAccount']['Card']['removeItem']['login']['swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Card']['removeItem']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }
          });
      }
    }
  }
</script>

<style scoped>

</style>